<template>
  <component
    :is="component.component.name"
    v-for="(component, index) in specificComponents"
    :key="`${keyPrefix}-${index}`"
    :component="component"
  ></component>
</template>

<script lang="ts">
// common
import Separator from '~/components/library/Separator.vue';
import FormContainer from '~/components/library/FormContainer.vue';

import InfoCard from '~/components/theme9/components/InfoCard.vue';
import TeamCard from '~/components/theme9/components/TeamCard.vue';
import LatestProperties from '~/components/theme9/properties/LatestProperties.vue';
import OurBlog from '~/components/theme9/blogs/OurBlog.vue';
import ManageCard from '~/components/library/ManageCard.vue';
import OurGuide from '~/components/theme9/components/OurGuide.vue';
import ContactFormCard from '~/components/theme9/components/ContactFormCard.vue';

export default defineNuxtComponent({
  props: {
    specificComponents: {
      required: false,
      default: () => [],
    },

    keyPrefix: {
      required: false,
      type: String,
      default: 'dynamicComponent',
    },
  },

  components: {
    Separator,
    FormContainer,
    InfoCard,
    TeamCard,
    LatestProperties,
    OurBlog,
    ManageCard,
    OurGuide,
    ContactFormCard,
  },
});
</script>
